// extracted by mini-css-extract-plugin
export default {"header":"ProfitabilityFormHeader_header__z+x9G"};